import { localeActions as localeActionsFromSlice } from '../reducers/locale';

export const localeActions = { locale: localeActionsFromSlice };
